mutation StartTugOfWar($tugId: ID!) {
  tug: StreamToolsStartTugOfWar(tugId: $tugId) {
    tugId
    status
    youtubeVotesEnabled
    startedAt
  }
}
